import { useId } from 'react';

export interface MarkEmblemProps {
  className?: string;
}

const MarkEmblem = ({ className }: MarkEmblemProps) => {
  const gradientId = useId();

  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <rect width="80" height="80" rx="40" fill={`url(#${gradientId})`} />
      <path
        d="M57.9037 40.4601C58.6558 39.3021 60.2038 38.9727 61.3617 39.7247C62.5195 40.4766 62.8487 42.0248 62.0971 43.1827L58.2387 49.1231C57.4867 50.281 55.9386 50.6103 54.7807 49.8585C53.6228 49.1065 53.2935 47.5584 54.0453 46.4005L57.9037 40.4601Z"
        fill="#66D4FF"
      />
      <path
        d="M51.0916 24.8324C51.8436 23.6744 53.3917 23.345 54.5496 24.097C55.7074 24.8489 56.0367 26.3971 55.285 27.555L41.3357 49.0335C40.5837 50.1914 39.0356 50.5199 37.8777 49.7679C36.7198 49.0159 36.3904 47.4678 37.1424 46.3099L51.0916 24.8324Z"
        fill="white"
      />
      <path
        d="M34.1865 24.6407C34.937 23.4821 36.4848 23.1513 37.6436 23.9014C38.8025 24.6519 39.1343 26.2005 38.3838 27.3594L18.0986 58.6807C17.3481 59.8396 15.7995 60.1705 14.6406 59.4199C13.4821 58.6694 13.1511 57.1217 13.9014 55.9629L34.1865 24.6407Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="16"
          y1="63"
          x2="80"
          y2="12"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#002D5D" />
          <stop offset="1" stopColor="#007AAB" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default MarkEmblem;
